import React from 'react'

import { Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

const MontoTotalFormGroup = ({ vMoneda, iValue }) => {
  return (
    <Form.Group>
      <Form.Label text={`MONTO TOTAL (${MonedasConstant.__dictionary[vMoneda].signo})`} htmlFor='number-montoTotal' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.InputNumber id='number-montoTotal' disabled value={iValue} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoTotalFormGroup)
